/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { IrisDMSFolderI } from '../../modules/dms/models/IrisDMSFolder';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { IrisQueryParamsBuilder } from '@iris/api-query';
import { ApiUrl, IrisApiClient } from '@iris/api-query';

@Injectable({ providedIn: 'root' })
@ApiUrl('/dms2/{iris@instanceId}/files/module')
export class IrisModuleFolderService extends IrisApiClient<any> {
  protected readonly httpClient: HttpClient;
  private readonly dialog = inject(MatDialog);

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  
    this.httpClient = httpClient;
  }

  @ApiUrl('~/{module}')
  getModuleFiles(module: string, subject): Observable<any> {
    const paramsBuilder = new IrisQueryParamsBuilder()
      .urlParam('subject', subject)
      .toStructure();

    return this.httpClient.get<any>(this.url({ module }), {
      params: paramsBuilder.toObject(),
    });
  }

  @ApiUrl('~/{module}?subject={subject}')
  getModuleFileUploadUrl(module: string, subject: unknown): string {
    return this.fullUrl({ module, subject: encodeURIComponent(JSON.stringify(subject)) });
  }

  @ApiUrl('/dms2/{iris@instanceId}/folders/{folderId}/files')
  getFoldersUploadUrl(folderId: string): string {
    return this.fullUrl({ folderId });
  }

  @ApiUrl('/dms2/{iris@instanceId}/files/{fileId}/content')
  getFileContentUploadUrl(fileId: string): string {
    return this.fullUrl({ fileId });
  }

  @ApiUrl('/dms2/{iris@instanceId}/folders/system/{module}')
  getSystemFolder(module: string, subject): Observable<IrisDMSFolderI> {
    return this.httpClient.get<IrisDMSFolderI>(this.url({ module }), {
      params: { subject: JSON.stringify(subject) },
    });
  }
}
